import { React } from "react";
import "./CheckboxIcon.css";

const CheckboxIcon = (props) => {
  return (
    <div className="icon-container">
      <div
        className={
          props.isChecked
            ? "checkbox-icon checkbox-icon-checked"
            : "checkbox-icon"
        }
      >
        {props.isChecked ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="6"
            viewBox="0 0 8 6"
            className="tick"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.66667 6L0 3.5L1.06667 2.5L2.66667 4L6.93333 0L8 1L2.66667 6Z"
              fill="white"
            />
          </svg>
        ) : null}
      </div>
    </div>
  );
};

export default CheckboxIcon;
